import { DecorationModel } from "../_model/DecorationModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors"
import * as d3 from "d3"

var ActualValue;
var maxOcup;
var minOcup;
export class DecorationOccupation extends DecorationModel {
  constructor() {
    super("DecorationOccupation")
    this.node = null;
  
    this.init = async function (newNode, openDialog) {
      let svg = SingletonFlowchart.svg
      this.node = newNode
      this.dialog = openDialog

      await svg
        .data([newNode])
        .append("g")
        .classed("Occupation", true)
        .attr("id", `Occupation-${newNode.id}`)
        .style("cursor", "pointer")
        .call(this.setDrag())

      let g = d3.select(`#Occupation-${newNode.id}`)

      ActualValue = Number(newNode.data[0].value.replace(',', '.'));
      maxOcup = Number(newNode.maximumOccupation.replace(',', '.'));
      minOcup = Number(newNode.minimumOccupation.replace(',', '.'));

      g.append("circle")
        .classed("OccupationCircle", true)
        .attr('r', 10)
        .style("fill", ActualValue > maxOcup || ActualValue < minOcup ? COLORS.Red : ActualValue == maxOcup || ActualValue == minOcup ? COLORS.OrangePentagro1 : COLORS.Energia) 
        .attr("cx", (d) => d.xCircle())
        .attr("cy", (d) => d.y + newNode.heightCircle)
        .on('dblclick', () => openDialog(newNode))
        .node();

      g.append('text')
        .classed("OccupationTitle", true)
        .attr("y", (d) => d.y + newNode.heightText)
        .attr("x", (d) => d.xText())
        .style('stoke', COLORS.Black90)
        .text(newNode.title)
        .on('dblclick', () => openDialog(newNode))
        .style('padding-right', 10)
        .node();

      g.append('text')
        .classed("OccupationValue", true)
        .attr("y", (d) => d.y + newNode.heightText)
        .attr("x", (d) => d.xTextValue())
        .attr("text-anchor", "middle")
        .style('stoke', COLORS.Black90)
        .text(`${String(Number(newNode.data[0].value.replace(',','.')).toFixed(3)).replace('.',',')} %`)
        .on('dblclick', () => openDialog(newNode))
        .node();

        this.setTextAndAdjustCircleColor(newNode.textInPixels);

      return svg
    }
  
    this.setDrag = function() {
      if(this.node.readOnly)
        return d3.drag();

      let that = this
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d, that))
        .on("end", (event, d) => that.dragended(event, d, that));

      return drag;
    }

    this.dragstarted = function(event, d) {
      SingletonFlowchart.clicked = true
      SingletonFlowchart.selectNode(d.idName);

      d3.select(`#${d.idName}`)
        .style("cursor", "grabbing")
    }

    this.dragged = async function (event, d, that) {
      SingletonFlowchart.clicked = false;

      d.x = event.x;
      d.y = event.y;
      
      that.move()
    }

    this.move = async () => {
      let d = this.node;
      d3.select(`#${d.idName} > text.OccupationTitle`).raise().attr("x", (d.xText())).attr("y", (d.y + d.heightText));
      d3.select(`#${d.idName} > text.OccupationValue`).raise().attr("x", (d.xTextValue())).attr("y", (d.y + d.heightText));
      d3.select(`#${d.idName} > circle.OccupationCircle`).raise().attr("cx", (d.xCircle())).attr("cy", (d.y + d.heightCircle));
    }

    this.dragended = function(event, d) {
      d3.select(`#${d.idName}`).style("cursor", "grab")

      SingletonFlowchart.SaveStatus();
    }

    this.setTextAndAdjustCircleColor = (numberOfCharacters) => {
      let d = this.node
      let textLength = d.title.length * 9;
      let title = textLength > numberOfCharacters ? `${d.title.slice(0, numberOfCharacters/9)}...` : d.title;

      ActualValue = Number(this.node.data[0].value.replace(',', '.'));
      maxOcup = Number(this.node.maximumOccupation.replace(',', '.'));
      minOcup = Number(this.node.minimumOccupation.replace(',', '.'));

      d3.select(`#${d.idName} > circle.OccupationCircle`)
        .transition()
        .duration(400)
        .style("fill", ActualValue > maxOcup || ActualValue < minOcup ? COLORS.Red : ActualValue == maxOcup || ActualValue == minOcup ? COLORS.OrangePentagro1 : COLORS.Energia)
        .node()
      
      d3.select(`#${d.idName} > text.OccupationTitle`)
        .attr("x", d.xText())
        .text(title)
        .node()
      
      d3.select(`#${d.idName} > text.OccupationValue`)
        .attr("x", (d) => d.xTextValue())
        .text(`${String(Number(d.data[0].value.replace(',','.')).toFixed(3)).replace('.',',')} %`)
        .node()
      
      d3.selectAll(`#${d.idName} > text.current-attr`).remove()
    }

    this.setReadyOnly = () => {
      return
    }
  }
}